let nextId = 0;

// Creates a unique ID for each LazyImport
export default function createImportId(): string {
    return (nextId++).toString();
}
